import PropTypes from 'prop-types';
import React from 'react';
import { Svg, Path } from 'react-native-svg';

const New = ({ className, size, color }) => {
    return (
        <Svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <Path
                d="M14.5 3.52787L17.1574 8.84262L22.4721 11.5L17.1574 14.1574L14.5 19.4721L11.8426 14.1574L6.52787 11.5L11.8426 8.84262L14.5 3.52787ZM13.3333 10.3333L11 11.5L13.3333 12.6667L14.5 15L15.6667 12.6667L18 11.5L15.6667 10.3333L14.5 8L13.3333 10.3333Z"
                clipRule="evenodd"
                fillRule="evenodd"
                fill={color}
            />
            <Path
                d="M8.5 15L9.66667 17.3333L12 18.5L9.66667 19.6667L8.5 22L7.33333 19.6667L5 18.5L7.33333 17.3333L8.5 15Z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill={color}
            />
            <Path
                d="M6.5 3L7.66667 5.33333L10 6.5L7.66667 7.66667L6.5 10L5.33333 7.66667L3 6.5L5.33333 5.33333L6.5 3Z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill={color}
            />
        </Svg>
    );
};

New.propTypes = {
    className: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
};

New.defaultProps = {
    className: '',
    size: '24px',
    color: 'currentColor',
};

export default New;
